<template>
  <div class="app-container">
    <!--表单组件-->
    <eForm ref="form" :is-add="isAdd"/>
    <el-row :gutter="10">
      <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>字典列表</span>
            <el-button
              class="filter-item"
              size="mini"
              style="float: right;padding: 4px 10px"
              type="primary"
              icon="el-icon-plus"
              @click="add()">新增</el-button>
          </div>
          <!--工具栏-->
          <div class="head-container">
            <!-- 搜索-->
            <dynamic-search
                :data="tableFilterList(tableHead)"
                @search="dataTableSearch">
            </dynamic-search>
          </div>
          <!--表格渲染-->
          <edit-data-table
          :head="tableHead"
          :data="list"
          :total="total"
          :offset="offset"
          :page="page"
          :loading="loading"
          highlight-current-row
          @handlePageChange="dataTablePageChange"
          @handleSizeChange="dataTableSizeChange"
          @current-change="handleCurrentChange"
          >
            <template #toolbar="scope">
              <el-button type="text" size="mini" icon="el-icon-edit" @click="edit(scope.row)"></el-button>
              <el-popover :ref="scope.row.id" placement="top" width="180">
                  <p>确定删除本条数据吗？</p>
                  <div style="text-align: right; margin: 0">
                      <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
                      <el-button :loading="delLoading" type="primary" size="mini" @click="subDelete(scope.row.id)">确定</el-button>
                  </div>
                  <el-button type="text" size="mini" icon="el-icon-delete" slot="reference" class="table-del-btn"></el-button>
              </el-popover>
            </template>
          </edit-data-table>
        </el-card>
      </el-col>
      <el-col :xs="24" :sm="24" :md="14" :lg="14" :xl="14">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>字典项</span>
              <el-button
                class="filter-item"
                size="mini"
                style="float: right;padding: 4px 10px"
                type="primary"
                icon="el-icon-plus"
                :disabled="!showButton"
                @click="addDetail()">新增</el-button>
            </div>
          <dictDetail ref="dictDetail"/>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import "@/components/EditDataTable"
import DynamicSearch from '@/components/DynamicSearch'
import DataTableMixin from '@/mixins/DataTableMixin'
import { del } from '@/api/dict'
import dictDetail from '../dictDetail'
import eForm from './form'
import { deepClone } from '@/utils/index'
export default {
  components: { DynamicSearch, dictDetail, eForm },
  mixins: [DataTableMixin],
  data() {
    return {
      delLoading: false,
      showButton: false,
      isAdd: false,
      tableHead: [
          {
              label: '字典名称',
              prop: 'name',
              query: {
                  type: 'input'
              },
              // sortable: true,
          },
          {
              label: '字典值',
              prop: 'code'
          }
      ]
    }
  },
  created() {
    // 列表数据初始化
    this.$nextTick(() => {
      this.dataTableInit();
    });
  },
  methods: {
     dataTableBeforeInit() {
        this._url = '/dict'
        const params = { page: this.page, size: this.offset }
        this._params = Object.assign(params,this._query)
        if (this.$refs.dictDetail) {
          this.$refs.dictDetail.data = []
          this.$refs.dictDetail.dictValue = ''
        }
        return true
    },
    subDelete(id) {
        this.delLoading = true
        del(id).then(res => {
            this.delLoading = false
            this.$refs[id].doClose()
            this.dleTableChangePage()
            this.dataTableInit()
            this.$notify({
                title: '删除成功',
                type: 'success',
                duration: 2500
            })
        }).catch(err => {
            this.delLoading = false
            this.$refs[id].doClose()
            console.log(err)
        })
    },
    handleCurrentChange(val) {
      if (val) {
        // 点击后显示按钮
        this.showButton = true
        this.$refs.dictDetail.dict = val
        this.$refs.dictDetail.dataTableInit()
      }
    },
    add() {
      this.isAdd = true
      const _this = this.$refs.form
      _this.form = {}
        _this.form.sorting = this.total + 1
      _this.dialog = true
    },
    edit(data) {
      this.isAdd = false
      const _this = this.$refs.form
      _this.form = deepClone(data)
      _this.dialog = true
    },
    addDetail() {
      const _this =  this.$refs.dictDetail
      // _this.form.sort = this.total + 1
      _this.$refs.form.form = {}
      _this.$refs.form.dialog = true
      _this.isAdd = true
    }
  }
}
</script>

<style scoped>

</style>
